/* Leendel — small progressive enhancements. Everything works without this file. */
(function () {
  var root = document.documentElement;
  window.LeendelReady = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Gentle fade-in for elements marked data-ld-reveal */
  function initReveal() {
    var items = document.querySelectorAll('[data-ld-reveal]:not(.is-visible)');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* 2. Product page: move the delivery / returns / care rows under the description,
        and the delivery note under the buy buttons. If anything is missing, the
        template stays hidden and the page is unchanged. */
  function initAssurance() {
    var tpl = document.getElementById('ld-assurance-template');
    if (!tpl) return;
    var details = document.querySelector('.product-details');
    if (!details) return;
    var frag = tpl.content.cloneNode(true);
    var rows = frag.querySelector('.ld-assurance');
    var note = frag.querySelector('.ld-delivery-note');
    var accordion = details.querySelector('.accordion');
    if (rows) {
      if (accordion && accordion.parentNode) accordion.parentNode.insertBefore(rows, accordion.nextSibling);
      else details.appendChild(rows);
    }
    var buy = details.querySelector('.buy-buttons-block, product-form-component, .product-form-buttons');
    if (note && buy) {
      var host = buy.closest('.buy-buttons-block') || buy;
      host.parentNode.insertBefore(note, host.nextSibling);
    }
  }

  /* 3. Product page: move the Loox star rating (only rendered once a product has
        real reviews) to sit directly under the price. Without JS it stays above
        the reviews section. */
  function initRating() {
    var rating = document.querySelector('.ld-loox-rating');
    var details = document.querySelector('.product-details');
    if (!rating || !details) return;
    var price = details.querySelector('product-price');
    if (price && price.parentNode) price.parentNode.insertBefore(rating, price.nextSibling);
  }

  function start() {
    root.classList.add('ld-js');
    initAssurance();
    initRating();
    initReveal();
    // Re-scan after section re-renders (theme editor, filters, quick add)
    document.addEventListener('shopify:section:load', initReveal);
    if ('MutationObserver' in window) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(initReveal, 120); })
        .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
